import { render, staticRenderFns } from "./gongdan_card.vue?vue&type=template&id=87b77592&scoped=true&"
import script from "./gongdan_card.vue?vue&type=script&lang=js&"
export * from "./gongdan_card.vue?vue&type=script&lang=js&"
import style0 from "./gongdan_card.vue?vue&type=style&index=0&id=87b77592&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b77592",
  null
  
)

export default component.exports